module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_429C.67629bed.jpg";